import { Component, OnInit } from '@angular/core';
import { EnvService } from '@forgerock/backstage-ui-core';
import { DashboardEnv } from '../model/dashboard-env';

@Component({
  selector: 'app-dashboard-university-panel',
  templateUrl: './dashboard-university-panel.component.html',
  styleUrls: [ './dashboard-university-panel.component.scss' ],
  standalone: false
})
export class DashboardUniversityPanelComponent implements OnInit {
  trainingUrl: string | null = null;

  constructor(private readonly envService: EnvService<DashboardEnv>) {}

  async ngOnInit(): Promise<void> {
    try {
      this.trainingUrl = (await this.envService.get()).trainingBaseUrl;
    } catch {
      this.trainingUrl = null;
    }
  }
}
